exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.vus-icon[data-v-3264fe58] {\n    vertical-align: -0.15em;\n    fill: currentColor;\n    overflow: hidden;\n}\n", "", {"version":3,"sources":["C:/vue/VusUI-master/src/components/vus-icon/vus-icon.vue"],"names":[],"mappings":";AACA;IACI,wBAAwB;IACxB,mBAAmB;IACnB,iBAAiB;CACpB","file":"vus-icon.vue","sourcesContent":["\n.vus-icon[data-v-3264fe58] {\n    vertical-align: -0.15em;\n    fill: currentColor;\n    overflow: hidden;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-3264fe58","scoped":true,"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/vus-icon/vus-icon.vue
// module id = 63
// module chunks = 0